var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file step-vertical组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash-es';

import { classPrefix } from '../../../common/util';

import './index.less';

var StepsVertical = function (_Component) {
    _inherits(StepsVertical, _Component);

    function StepsVertical() {
        _classCallCheck(this, StepsVertical);

        return _possibleConstructorReturn(this, (StepsVertical.__proto__ || Object.getPrototypeOf(StepsVertical)).apply(this, arguments));
    }

    _createClass(StepsVertical, [{
        key: 'showStepsLines',
        value: function showStepsLines() {
            var _props = this.props,
                current = _props.current,
                steps = _props.steps,
                height = _props.height;

            var style = {
                height: height / 2
            };
            return _.range(steps.length - 1).map(function (item, idx) {
                return [React.createElement('div', { key: idx + 'first',
                    className: classnames({
                        'steps-lines': true,
                        'steps-lines-done': idx < current || idx === current
                    }),
                    style: style
                }), React.createElement('div', { key: idx + 'second',
                    className: classnames({
                        'steps-lines': true,
                        'steps-lines-done': idx < current
                    }),
                    style: style
                })];
            });
        }
    }, {
        key: 'showStepsContent',
        value: function showStepsContent() {
            var _this2 = this;

            var steps = this.props.steps;
            return steps.map(function (item, idx) {
                return React.createElement(
                    'div',
                    { key: idx,
                        className: 'steps-content',
                        style: {
                            top: _this2.props.height * idx
                        }
                    },
                    _this2.renderStepIcon(item, idx),
                    _this2.renderStepText(item, idx)
                );
            });
        }
    }, {
        key: 'renderStepIcon',
        value: function renderStepIcon(item, idx) {
            var current = this.props.current;
            var isDone = idx < current;
            return React.createElement(
                'div',
                { className: classnames({
                        'steps-icon-normal': !isDone,
                        'steps-icon-current': !isDone && idx === current,
                        'steps-icon-done': isDone
                    }) },
                !isDone && idx + 1
            );
        }
    }, {
        key: 'renderStepText',
        value: function renderStepText(item, idx) {
            var current = this.props.current;
            var isDoneAndisDoing = idx <= current;
            return React.createElement(
                'div',
                { className: 'steps-text-wrap' },
                React.createElement(
                    'div',
                    { className: classnames({
                            'steps-text': true,
                            'steps-text-done': isDoneAndisDoing
                        }) },
                    item.title
                ),
                React.createElement(
                    'div',
                    { className: classnames({
                            'steps-description': true,
                            'step-description-doing': idx === current
                        }) },
                    item.description
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames;

            var _props2 = this.props,
                className = _props2.className,
                classPrefix = _props2.classPrefix,
                steps = _props2.steps;

            if (steps.length < 2) {
                return null;
            }
            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, className, !!className), _defineProperty(_classnames, classPrefix + '-steps-wrap-vertical', true), _classnames));
            return React.createElement(
                'div',
                { className: rootClass },
                this.showStepsLines(),
                this.showStepsContent()
            );
        }
    }]);

    return StepsVertical;
}(Component);

StepsVertical.propTypes = {
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    current: PropTypes.number,
    steps: PropTypes.array,
    height: PropTypes.number
};
StepsVertical.defaultProps = {
    classPrefix: classPrefix,
    current: 0,
    steps: [],
    height: 100
};
export default StepsVertical;